const Header = ({ editMode }) => {
    return (
      <h1 className="text-[30px] leading-[43px] sm:text-4xl md:text-6xl md:text-[40px] mb-3 mx-auto sm:max-w-[800px]">
        {editMode ? "Edit Mode" : "Looks good?"}
      </h1>
    );
};
  
export default Header;  